export default function TopicsScreen({ gradeInfo, onBack, onSelectTopic }) {
  return (
    <div className="slide-up" style={{ position: "relative", zIndex: 1, padding: "40px 20px", maxWidth: "800px", margin: "0 auto" }}>
      <button onClick={onBack} style={{
        background: "rgba(255,255,255,0.1)",
        border: "1px solid rgba(255,255,255,0.2)",
        borderRadius: "12px",
        color: "white",
        padding: "8px 18px",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: 700,
        marginBottom: "24px",
        display: "flex",
        alignItems: "center",
        gap: "6px",
      }}>
        ← Back
      </button>

      <div style={{ textAlign: "center", marginBottom: "40px" }}>
        <div style={{ fontSize: "56px", marginBottom: "8px" }}>{gradeInfo.emoji}</div>
        <h1 style={{
          fontFamily: "'Fredoka One', cursive",
          color: gradeInfo.color,
          fontSize: "clamp(32px, 6vw, 48px)",
          margin: 0,
          textShadow: `0 0 30px ${gradeInfo.color}66`,
        }}>
          {gradeInfo.label} Math
        </h1>
        <p style={{ color: "#a0b4ff", marginTop: "8px" }}>Choose a topic to practice</p>
      </div>

      <div style={{ display: "grid", gap: "16px" }}>
        {gradeInfo.topics.map((topic, idx) => (
          <div
            key={topic.id}
            className="topic-card"
            onClick={() => onSelectTopic(topic)}
            style={{
              background: "rgba(255,255,255,0.05)",
              border: `2px solid ${gradeInfo.color}44`,
              borderRadius: "20px",
              padding: "24px 28px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "20px",
              transition: "all 0.2s ease",
              backdropFilter: "blur(10px)",
              animation: `slideUp 0.4s ease ${idx * 0.1}s both`,
            }}
          >
            <div style={{
              width: "60px",
              height: "60px",
              borderRadius: "16px",
              background: `linear-gradient(135deg, ${gradeInfo.color}44, ${gradeInfo.color}22)`,
              border: `2px solid ${gradeInfo.color}66`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "28px",
              flexShrink: 0,
            }}>
              {topic.emoji}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontFamily: "'Fredoka One', cursive", color: "white", fontSize: "22px" }}>{topic.name}</div>
              <div style={{ color: "#8a9fd4", fontSize: "14px", marginTop: "4px" }}>{topic.description}</div>
              <div style={{ color: gradeInfo.color, fontSize: "13px", marginTop: "6px", fontWeight: 700 }}>
                {topic.problems.length} problems
              </div>
            </div>
            <div style={{ color: gradeInfo.color, fontSize: "24px" }}>→</div>
          </div>
        ))}
      </div>
    </div>
  );
}
